/* ==========================================================================
   BabyCruiser — Scroll Animations (mirrors FlowCraft approach)
   GSAP + ScrollTrigger loaded from CDN in theme.liquid
   ========================================================================== */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    gsap.registerPlugin(ScrollTrigger);

    var scope = document.getElementById('MainContent');
    if (!scope) return;

    // Unit containers — these animate as a whole piece (cards, trust items)
    var UNIT_SEL = '[class*="__card"], .bc-post-card, .bc-tb__item';

    // Helper: does the element have at least one bc- class?
    function isBcEl(el) {
      return Array.from(el.classList).some(function (c) { return c.startsWith('bc-'); });
    }

    // ── Auto-animate: headings, text, CTAs ──
    // Grouped by direct parent so siblings stagger together
    var AUTO_SEL = [
      'h1', 'h2', 'h3', 'h4',
      'p',
      '.bc-btn',
      '[class*="__eyebrow"]',
    ].join(', ');

    var textEls = gsap.utils.toArray(AUTO_SEL, scope);
    var textGroups = new Map();

    textEls.forEach(function (el) {
      // Skip elements inside unit containers — the unit animates as a whole
      if (el.closest(UNIT_SEL)) return;
      // Skip progress bar, sr-only, and other utility elements
      if (el.closest('#bc-read-progress, [class*="sr-only"], [class*="visually-hidden"]')) return;

      var p = el.parentElement;
      if (!textGroups.has(p)) textGroups.set(p, []);
      textGroups.get(p).push(el);
    });

    textGroups.forEach(function (els, parent) {
      gsap.set(els, { opacity: 0, y: 20 });
      gsap.to(els, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        ease: 'power2.out',
        stagger: 0.08,
        scrollTrigger: {
          trigger: parent,
          start: 'top 88%',
          once: true,
        },
      });
    });

    // ── Unit containers: animate whole card/item as one piece, stagger siblings ──
    var unitEls = gsap.utils.toArray(UNIT_SEL, scope)
      .filter(function (el) { return isBcEl(el); });

    var unitGroups = new Map();
    unitEls.forEach(function (el) {
      var p = el.parentElement;
      if (!unitGroups.has(p)) unitGroups.set(p, []);
      unitGroups.get(p).push(el);
    });

    unitGroups.forEach(function (els, parent) {
      gsap.set(els, { opacity: 0, y: 22 });
      gsap.to(els, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        stagger: 0.1,
        scrollTrigger: {
          trigger: parent,
          start: 'top 88%',
          once: true,
        },
      });
    });

    // ── Images: fade in only, no y movement ──
    // Skip: images inside unit containers (the card handles the reveal)
    // Skip: eager/high-priority images (above the fold — hero etc.)
    gsap.utils.toArray('img', scope).forEach(function (el) {
      if (el.closest(UNIT_SEL)) return;
      if (el.getAttribute('loading') === 'eager') return;
      if (el.getAttribute('fetchpriority') === 'high') return;
      gsap.set(el, { opacity: 0 });
      gsap.to(el, {
        opacity: 1,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          once: true,
        },
      });
    });
  });
})();
